<template>
    <div class="christmas">
       <div class="christmas__header">
           <div class="christmas__header__background">
               <v-lazy-image class="christmas__header__background__image desktop" :src="require('@/assets/img/xmas/header.png')"></v-lazy-image>
               <v-lazy-image class="christmas__header__background__image mobile" :src="require('@/assets/img/xmas/header-mobile.png')"></v-lazy-image>
           </div>
           <div class="christmas__header__content">
                <div class="container">
                    <div class="christmas__header__content__inner">
                       <div class="christmas__header__content__title" :class="{'christmas__header__content__title--de' : $language.current === 'de'}">
                            <span class="christmas__header__content__title__gold" :class="{'christmas__header__content__title__gold--de' : $language.current === 'de'}">
                                <translate>christmas</translate>   
                            </span> 
                            <span class="christmas__header__content__title__white">
                                <translate>calendar</translate>
                            </span>
                        </div>
                        <div class="christmas__header__content__exclusive">
                            <div class="christmas__header__content__exclusive__date__frame">
                                <div class="christmas__header__content__exclusive__date">24</div>
                            </div>
                            <div class="christmas__header__content__exclusive__title h5">
                                <translate>exclusive_wintery_workouts</translate>
                            </div>
                        </div>
                        <div class="christmas__header__content__text info text text--large">
                            <translate>christmas_header_description</translate>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="christmas__body" :class="isMobileNav ? 'christmas__body--mobile' : 'christmas__body--desktop'">
           <div class="container">
               <div class="christmas__body__inner">
                    <ChristmasWorkoutCard v-for="(workout, index) in sortedWorkouts" :key="index" class="christmas__body__card" :big="setCardSize(index)" :workout="workout" :disabled="isDisabled(index)"/>
                </div>
           </div>
        </div>
        <div class="christmas__footer">
            <div class="christmas__footer__primary">
                <div class="christmas__footer__primary__inner container">
                    <router-link tag="a" to="/" class="christmas__footer__primary__logo">
                        <img src="../assets/trac-logo-light.svg" alt="Logo Pumatrac">
                    </router-link>
                    <div class="christmas__footer__primary__links">
                        <div class="text christmas__footer__primary__links__label" v-translate>download_now_christmas</div>
                        <div class="christmas__footer__primary__links__store">
                            <a href="https://play.google.com/store/apps/details?id=com.pumapumatrac" target="_blank" class="text christmas__footer__primary__links__apps playstore">
                                <img src="../assets/img/play-store.svg" alt="Play Store">
                            </a>
                            <a href="https://apps.apple.com/us/app/pumatrac-training-running/id698298978" target="_blank" class="text christmas__footer__primary__links__apps">
                                <img src="../assets/img/appstore.svg" alt="App Store">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="christmas__footer__secondary">
                <div class="christmas__footer__secondary__inner container">
                    <a href="https://go.puma.com/koswb" class="christmas__footer__secondary__link text" v-translate>puma_com_christmas</a>
                    <div class="christmas__footer__secondary__copyright text" v-translate>rights_reserved</div>
                    <a :href="$gettext('imprit_legal_link')" class="christmas__footer__secondary__link text" v-translate>imprint_legal</a>
                </div>
            </div>
        </div>
        <Newsletter/>
    </div>
</template>

<script>
    import * as api from '../api'
    import ChristmasWorkoutCard from "@/components/ChristmasWorkoutCard.vue"
    import Newsletter from "@/components/Newsletter.vue"
    import { mapGetters } from "vuex"
    export default {
        components: {
            ChristmasWorkoutCard,
            Newsletter,
        },
        computed: {
            ...mapGetters(['christmasWorkoutIds', 'isMobileNav', 'isNotebook']),
            sortedWorkouts() {
                 return this.workouts.sort((a, b) => a.order - b.order );
            },

            bigCards() {
                if(this.isNotebook) {
                    return [1, 9, 18];
                } else {
                    return [2, 8 , 14, 20];
                }
            }
        },
        data() {
            return {
                workouts: [],
                streaming: [0, 6, 18],
                index: 1,
            }
        },
        mounted() {
            this.fetchData();
            this.checkLanguage();
        },
        methods: {
            checkLanguage() {
                const url = new URL(window.location.href);
                const lang = url.searchParams.get("lang");
                if(lang === 'en') {
                    this.$language.current = lang;
                    localStorage.setItem('pmcLanguage', lang);
                } else {
                    this.$language.current = 'de'
                    localStorage.setItem('pmcLanguage', 'de');
                }
            },
           async fetchData() {
                try {
                    const response = await api.workout.all();
                    response.data.data.forEach((w) => {
                        this.christmasWorkoutIds.forEach((card,index) => {
                            if(card.id.indexOf(w.id) >= 0) {
                               
                                if(card.order < 10) w.cid = ('0' + card.order).slice(-2);
                                else w.cid = card.order;
                                w.category = card.category;
                                w.order = card.order;
                                if (this.streaming.includes(index)) w.kind = 'stream';
                                this.workouts.push(w);
                                this.index ++;
                            }
                        })
                        // if(this.christmasWorkoutIds.indexOf(w.id) >= 0) {
                        //     if(this.index < 10) w.cid = ('0' + this.index).slice(-2);
                        //     else w.cid = this.index;
                        //     this.workouts.push(w);
                        //     this.index ++;
                        // }
                    });
                } catch (error) {
                    console.error(error);
                }
            },
            setCardSize(index) {
                if (this.bigCards.includes(index)) return true
                return false
            },
            isDisabled(index) {
                const date = new Date();
                const currentMonth = date.getMonth() + 1;
                const currentDate = date.getDate();
                if(currentMonth === 12 && currentDate > index) {
                // if(currentMonth === 11 && currentDate > index) {
                    return false;
                }
               else  return true;
            }
       }
    }
</script>
<style lang="scss">
    .christmas {
        $block: &;
        background: $puma-color-black;
        color: $puma-color-white;

        &__header {
            position: relative;

            &::after {
		        content: '';
                display: block;
            }

            &__background {
                padding-bottom: 186%;
                background-color: $puma-color-black;
                @include fillout;
                top: -99px;

                @include mq(tablet) {
                    padding-bottom: 47.9%;
                    top: -64px;
                }

                &__image {
                    object-fit: cover;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;

                    &.desktop {
                        display: none;

                        @include mq(tablet) {
                            display: inline;
                        }
                    }

                    &.mobile {
                        display: inline;

                        @include mq(tablet) {
                            display: none;
                        }
                    }
                }
	        }

            &__content {
                position: relative;
		        display: flex;
		        align-items: center;
		        z-index: 2;

                &__inner {
                    padding-top: 64px;
                    padding-bottom: 64px;
                    display: flex;
                    align-items: center;
                    flex-direction: column;

                    @include mq(tablet) {
                        padding-top: 80px;
                        padding-bottom: 80px;
                    }
                }

                &__title {
                    font-size: $puma-size-font-4xl;
                    line-height: 0.94;
                    text-transform: uppercase;
                    display: block;
                    display: flex;
                    flex-direction: column;

                    @include mq(tablet) {
                        font-size: $puma-size-font-7xl;
                        flex-direction: row;
                    }
                    
                    &__gold {
                        font-weight: 700;
                        color: $puma-color-accent-40;
                        margin-right: 16px;

                        &--de {
                            margin-right: 0;
                        }
                    }

                    &__white {
                        color: $puma-color-white;
                    }

                    &--de {
                        flex-direction: row;
                    }
                }

                &__exclusive {
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    margin: 32px 0;

                    @include mq(tablet) {
                        flex-direction: row;
                    }
                    
                    &__date {
                        font-size: $puma-size-font-7xl;
                        line-height: 1;
                        font-weight: 700;
                        color: $puma-color-white;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);

                        &__frame {
                            width: 100px;
                            height: 91px;
                            position: relative;

                            &:before {
                                content: "";
                                width: 100%;
                                height: 100%;
                                position: absolute;
                                z-index: 1;
                                top: 0;
                                left: 0;
                                -webkit-filter: blur(1px);
                                filter: blur(1px);
                                border-radius: 4px;
                                border-style: solid;
                                border-width: 1px;
                                border-image-source: linear-gradient(227deg, rgba($puma-color-white, 0.9) 93%, rgba($puma-color-white, 0.3) 55%, rgba($puma-color-white, 0.9) 8%);
                                border-image-slice: 1;
                            }
                        }
                    }

                    &__title {
                        color: $puma-color-white;
                        margin-top: 21px;
                        max-width: 250px;
                        display: block;
                        text-align: center;

                        @include mq(tablet) {
                            margin-left: 23px;
                            margin-top: 0;
                            display: inline-block;
                            text-align: left;
                        }
                    }
                }

                &__text {
                    color: $puma-color-neutral-10;
                    max-width: 250px;
                    text-align: center;
                    margin-left: 7px;

                    @include mq(tablet) {
                        max-width: 550px;
                    }
                }
            }
        }

        &__body {
            position: relative;

            &--desktop {
                &::after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    background: url('../assets/img/xmas/footer-desktop.png');
                    background-size: cover;
                    padding-bottom: 29.65%;
                    width: 100%;
                }
            }

            &--mobile {
                &::after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    background: url('../assets/img/xmas/footer-mobile.png');
                    padding-bottom: 58.66%;
                    background-size: cover;
                    width: 100%;
                }   
            }

            &__inner {
                display: grid;
                grid-gap: 10px;
                grid-template-columns: repeat(2, minmax(153px,1fr));
                grid-auto-rows: auto;
                padding-bottom: 175px;

                @include mq(mobile-landscape) {
                    grid-template-columns: repeat(auto-fill, minmax(162px,1fr));
                }

                @include mq(tablet) {
                    grid-gap: 12px;
                    grid-template-columns: repeat(auto-fill, minmax(330px,1fr));
                }

                @include mq(notebook) {
                    grid-auto-rows: 220px;
                    grid-template-columns: repeat(4, minmax(330px,1fr));
                }
            }

            &__card {
                grid-row-end: span 1;
                position: relative;
                z-index: 3;

                &--big {
                    grid-row-end: span 2;
                }
            }
        }

        &__footer {
            &__primary {
                padding: 20px 0 24px 0;
                border-bottom: 1px solid rgba($puma-color-white, 0.2);

                @include mq(tablet) {
                    padding: 70px 0;
                }

                &__inner {
                    display: flex;
                    flex-direction: column;

                    @include mq(tablet) {
                        justify-content: space-between;
                        align-items: center;
                        flex-direction: row;
                    }
                }

                &__logo {
                    height: 24px;
                    width: 70px;
                    position: relative;
                    margin-bottom: 16px;

                    @include mq(tablet) {
                        height: 39px;
                        width: 114px; 
                        margin-bottom: 0; 
                    }

                    img {
                        @include fillout();
                        object-fit: cover;
                        width: 100%;
                        height: 100%;
                    }
                }

                &__links {
                    display: flex;
                    flex-direction: column;

                    @include mq(tablet) {
                        flex-direction: row;
                    }

                    &__label {
                        color: $puma-color-neutral-10;
                        display: flex;
                        align-items: center;
                        margin-bottom: 8px;

                        @include mq(tablet) {
                            margin-bottom: 0;
                        }
                    }

                    &__store {
                        display: flex;
                        flex-direction: row;
                    }

                    &__apps {
                        height: 40px;
                        width: 135px;
                        position: relative;
                        border: 1px solid $puma-color-white;

                        &.playstore {
                            margin-left: 0;
                            margin-right: 20px;

                            @include mq(tablet) {
                                margin-left: 40px;
                                margin-right: 25px;
                            }
                        }

                        img {
                            @include fillout();
                            object-fit: cover;
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
            }

            &__secondary {
                padding: 16px 0 24px 0;

                @include mq(tablet) {
                    padding: 40px 0;
                }

                &__inner {
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    align-items: center;
                }

                &__link {
                    color: $puma-color-white;
                    display: block;
                    order: 2;
                }

                &__copyright {
                    color: $puma-color-neutral-10;
                    order: 3;
                    margin: 16px auto 0 auto;

                    @include mq(tablet) {
                        margin: 0;
                    }
                }
            }
        }
        
    }
</style>
